// Las escalas reflejan CommercializerCommissionService del backend.
const EXTENDED_NAMES = new Set(["PARRA TAMARA","IBARRA MARCOS","FALCON GRETA NATASHA"]);
const STANDARD_NAMES = new Set(["IBARRA JUAN","BERON MIGUEL ANGEL","BERON DIEGO","ALICO FEDERICO","DE LUCA MATIAS"]);
const FIXED_PERCENTAGES = {
  "LUNGHITANO SANTIAGO": 12,
  "COVELLI FRANCISCO": 12,
  "FINGURU": 5,
  "FINMARVI": 15,
  "RIVAROLA PAOLA": 13,
  "STABILE JORGELINA ROSA": 13
};
const SPECIAL_NAMES_BY_CUIT = {
  "20282803187": "ALICO FEDERICO",
  "27330327605": "FALCON GRETA NATASHA",
  "20167659420": "CLAVIJO CARLOS",
  "20283390226": "IBARRA JUAN",
  "20362734909": "LUNGHITANO SANTIAGO",
  "30716893207": "FINGURU",
  "20379784926": "COVELLI FRANCISCO",
  "27258209635": "STABILE JORGELINA ROSA",
  "20262505015": "BERON DIEGO",
  "27289922631": "RIVAROLA PAOLA",
  "20200243057": "IBARRA MARCOS",
  "30715666215": "FINMARVI",
  "20327640047": "DE LUCA MATIAS",
  "27442055624": "PARRA TAMARA",
  "20055085499": "BERON MIGUEL ANGEL"
};

const BASE_LINES = [
  '- Hasta $11.000.000: 7%',
  '- De $11.000.001 a $20.000.000: 9%',
  '- De $20.000.001 a $30.000.000: 10%',
];

export const getCommercializerCommissionNotice = (commercializer) => {
  const cuit = String(commercializer?.cuit || '').replace(/\D/g, '');
  const name = SPECIAL_NAMES_BY_CUIT[cuit] || String(commercializer?.nameAndLastName || '').trim().toUpperCase();
  if (EXTENDED_NAMES.has(name)) return [...BASE_LINES,
    '- De $30.000.001 a $40.000.000: 11%',
    '- De $40.000.001 a $50.000.000: 12%',
    '- De $50.000.001 a $60.000.000: 13%',
    '- Más de $60.000.000: 14%',
  ];
  if (STANDARD_NAMES.has(name)) return [...BASE_LINES,
    '- De $30.000.001 a $60.000.000: 11%',
    '- Más de $60.000.000: 12%',
  ];
  if (name === 'CLAVIJO CARLOS') return [
    '- Hasta $15.000.000: 11%',
    '- Más de $15.000.000: 12%',
  ];
  if (Object.prototype.hasOwnProperty.call(FIXED_PERCENTAGES, name)) return [
    '- Comisión fija: ' + FIXED_PERCENTAGES[name] + '%',
  ];
  return [...BASE_LINES, '- Más de $30.000.000: 11%'];
};
